export default __webpack_public_path__ + "static/media/Belt of the Exorcist.ff60f6f2.jpg";